import React from "react";
import "./AnimatedCenterSection.css";
import backgroundImage from "../Assets/animatedbg.png";  // or image10.png
import centerImage from "../Assets/animatedpop.png";

const AnimatedCenterSection = () => {
  return (
    <section
      className="animated-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="center-icon-wrapper">
        <img src={centerImage} alt="Center Animated Icon" className="center-icon" />
      </div>
    </section>
  );
};

export default AnimatedCenterSection;
